module.exports = __webpack_public_path__ + "static/media/1.db11fa56.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/tablet/1.png
// module id = 2496
// module chunks = 0